// rp-ui base CSS ships in react_islands.css (not common.css), postcss-scoped to
// [data-react-island-root] with rem scaling for webstore's 16px document root.
import '@encodium/rp-ui/rp-ui.css';

import domready from 'domready';
import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

// Intent recorder must load before mount so pre-bundle clicks are captured.
// file contains a guard so it's not loaded twice - this is a safety net
require('public/js/lib/intents');

import { loadIslandModule } from './load-island';
import { mountIslands } from './mount-islands';
import { readIslandProps } from './read-island-props';

domready(() => {
	mountIslands({
		createElement: React.createElement,
		createRoot,
		hydrateRoot,
		loadIslandModule,
		readProps: readIslandProps,
	}).catch((mountError) => {
		console.error('react-islands: mount failed', mountError);
	});
});
